import { Component } from '@theme/component';

/**
 * @typedef {{ colorName?: HTMLElement, cta?: HTMLAnchorElement }} Refs
 */

/** @extends {Component<Refs>} */
class NaProductSpotlightComponent extends Component {
    /** @param {Event} event */
    selectColor(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.checked) return;

        for (const media of this.querySelectorAll('[data-color-key]:not(input)')) {
            media.toggleAttribute('hidden', media.getAttribute('data-color-key') !== input.dataset.colorKey);
        }

        const { colorName, cta } = this.refs;
        if (colorName) colorName.textContent = input.dataset.colorName ?? '';
        if (cta && input.dataset.url) cta.href = input.dataset.url;
    }
}

if (!customElements.get('na-product-spotlight-component')) {
    customElements.define('na-product-spotlight-component', NaProductSpotlightComponent);
}
